import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { EdiPricatActionConfigService } from '../../../services/edi-pricat-action-config/edi-pricat-action-config.service';

@Component({
  selector: 'lib-edi-pricat-card-list',
  templateUrl: './edi-pricat-card-list.component.html',
  styleUrls: ['./edi-pricat-card-list.component.css'],
  standalone: false
})
export class EdiPricatCardListComponent extends ListItemRendererComponent<any[]> implements OnInit, AfterViewInit {
  public actionConfigService = inject(EdiPricatActionConfigService);

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  trackByFn(index: any, item: any) {
    return item.id;
  }
}
